import React, { CSSProperties } from 'react';
import Icon from '../../muiComponents/Icon';

interface DotIconProps {
    truthy?: boolean;
    falsy?: boolean;
    restStyles?: CSSProperties;
}
const DotIcon = (props: DotIconProps) => {
    const { truthy, falsy, restStyles, ...restProps } = props;
    const truthyColor = '#2E8B57';
    const falsyColor = '#D0D0D0';

    const color = (() => {
        if (truthy) return truthyColor;
        if (falsy) return falsyColor;
    })();

    return (
        <Icon
            iconName='FiberManualRecord'
            style={{
                color,
                fontSize: '14px',
                ...restStyles,
            }}
            {...restProps}
        />
    );
};

export default DotIcon;
